import { useEffect, useRef } from 'react';

const useWindowClose = (userId, username, sessionId) => {
  console.log('🔌 useWindowClose montado:', { userId, username, sessionId });

  // Flag para evitar múltiples ejecuciones
  const sesionCerradaRef = useRef(false);

  useEffect(() => {
    if (!userId) {
      return;
    }

    console.log('✅ useWindowClose: Registrando eventos de cierre mejorados');

    // Reset del flag al montar
    sesionCerradaRef.current = false;

    // Avisa al backend que se cerró la ventana, solo para el monitoreo. Ya NO
    // borra el token (oct 2026): estos eventos también saltan con F5, al cerrar
    // una sola pestaña (el token es compartido) o cuando el celular descarta el
    // navegador, y eso tiraba al usuario. La sesión la cortan la inactividad de
    // 2 hs (también al reabrir, ver utils/inactividad), las 12 hs o el botón Salir.
    const cerrarSesion = () => {
      // Evitar ejecuciones duplicadas
      if (sesionCerradaRef.current) {
        return;
      }
      sesionCerradaRef.current = true;

      const data = JSON.stringify({
        userId,
        username,
        sessionId,
        // El backend lo usa para comprobar quién avisa (no hay header en un beacon)
        refreshToken: localStorage.getItem('refreshToken') || undefined,
        timestamp: new Date().toISOString()
      });

      const url = `${process.env.REACT_APP_API_URL}/logout-on-close`;
      console.log('📡 Enviando beacon a:', url);

      const sent = navigator.sendBeacon(url, data);
      console.log('📡 Beacon enviado:', sent ? '✅ SI' : '❌ NO');
    };

    // beforeunload - Principal evento de cierre
    const handleBeforeUnload = (e) => {
      console.log('⚠️ beforeunload - Ventana/pestaña cerrándose');

      // Ejecutar cierre SOLO si realmente están cerrando
      cerrarSesion();
    };

    // unload - Backup robusto
    const handleUnload = () => {
      console.log('🚪 unload - Respaldo de cierre');
      cerrarSesion();
    };

    // pagehide - Crítico para móviles y Safari
    const handlePageHide = (e) => {
      console.log('📱 pagehide - Detectado en móvil/Safari');

      // Solo cerrar si es un cierre real (no cambio de pestaña)
      if (e.persisted) {
        console.log('ℹ️ Página en caché (back/forward), NO cerrar sesión');
        return;
      }

      cerrarSesion();
    };

    // Registrar eventos (SIN visibilitychange para evitar cierres accidentales)
    window.addEventListener('beforeunload', handleBeforeUnload);
    window.addEventListener('unload', handleUnload);
    window.addEventListener('pagehide', handlePageHide);

    console.log('✅ Eventos registrados:', {
      beforeunload: '✓ (Cierre principal)',
      unload: '✓ (Backup)',
      pagehide: '✓ (Móviles/Safari)',
      note: 'NO usa visibilitychange para evitar cierres al cambiar pestaña'
    });

    return () => {
      console.log('🧹 Limpiando listeners');
      window.removeEventListener('beforeunload', handleBeforeUnload);
      window.removeEventListener('unload', handleUnload);
      window.removeEventListener('pagehide', handlePageHide);
    };
  }, [userId, username, sessionId]);
};

export default useWindowClose;